// extracted by mini-css-extract-plugin
export var industry = "industry-module--industry--1_sen";
export var detail = "industry-module--detail--1Y_VN";
export var header = "industry-module--header--2-Cc8";
export var detailHeader = "industry-module--detailHeader--3-TR4";
export var cardGrid = "industry-module--cardGrid--N097S";
export var card = "industry-module--card--2fvg7";
export var cardImage = "industry-module--cardImage--3Q2A9";
export var cardText = "industry-module--cardText--2B9wi";
export var backLink = "industry-module--backLink--2O1EF";
export var heroImage = "industry-module--heroImage--89izb";
export var containImage = "industry-module--containImage--2pDM2";
export var detailGrid = "industry-module--detailGrid--1pP16";
export var detailText = "industry-module--detailText--29USf";
export var sectionDate = "industry-module--sectionDate--3glEl";